<template>
  <el-table border :data="tableData" stripe :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    style="width: 100%">
    <el-table-column :label="$t('reviewexpertstatus.id', { msg: ' reviewexpertstatus.id' })" prop="id" width="50">
    </el-table-column>
    <el-table-column :label="$t('reviewexpertstatus.username', { msg: ' reviewexpertstatus.username' })" prop="username"
      width="150">
    </el-table-column>
    <el-table-column :label="$t('reviewexpertstatus.phonenumber', { msg: ' reviewexpertstatus.phonenumber' })"
      prop="phoneNumber" width="150">
    </el-table-column>
    <!-- <el-table-column 
     :label="$t('reviewexpertstatus.password', { msg: ' reviewexpertstatus.password' })"
     prop="password">
     </el-table-column> -->
    <el-table-column :label="$t('reviewexpertstatus.name', { msg: ' reviewexpertstatus.name' })" prop="name">
    </el-table-column>
    <el-table-column :label="$t('reviewexpertstatus.email', { msg: ' reviewexpertstatus.email' })" prop="email"
      width="220">
    </el-table-column>
    <!-- <el-table-column 
     :label="$t('reviewexpertstatus.phonenumber', { msg: ' reviewexpertstatus.phonenumber' })"
     prop="companyName">
     </el-table-column> -->
    <!-- <el-table-column
       prop="roleName"
       :label="$t('reviewexpertstatus.role', { msg: ' reviewexpertstatus.role' })"
       width="180">
       <template #default="scope">
                 <span>
                   <span v-if="scope.row.roleId == 4" style="font-family:bold; color: rgb(50, 107, 192);">{{ $t('reviewexpertstatus.outsider', { msg: 'reviewexpertstatus.outsider' }) }}</span>
                   <span v-else-if="scope.row.roleId == 5" style="font-family:bold; color: hsl(180, 82%, 39%);">{{ $t('reviewexpertstatus.expert', { msg: 'reviewexpertstatus.expert' }) }}</span>
                   <span v-else-if="scope.row.roleId == 3" style="font-family:bold; color: hsl(180, 82%, 39%);">{{ $t('reviewexpertstatus.customer', { msg: 'reviewexpertstatus.customer' }) }}</span>
                 </span>
             </template>
</el-table-column> -->
    <el-table-column prop="isExpert" :label="$t('reviewexpertstatus.isExpert', { msg: ' reviewexpertstatus.isExpert' })"
      width="150">
      <template #default="scope">
        <span>
          <span v-if="scope.row.isExpert == 1" style="font-family:bold; color: rgb(18, 179, 58);">{{
    $t('reviewexpertstatus.passto', { msg: 'reviewexpertstatus.passto' }) }}</span>
          <span v-else-if="scope.row.isExpert == 0" style="font-family:bold; color: rgb(154, 218, 51);">{{
    $t('reviewexpertstatus.passun', { msg: 'reviewexpertstatus.passun' }) }}</span>
          <span v-else-if="scope.row.isExpert == 2" style="font-family:bold; color: rgb(179, 18, 31);">{{
    $t('reviewexpertstatus.passno', { msg: 'reviewexpertstatus.passno' }) }}</span>
        </span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('reviewexpertstatus.registrytime', { msg: ' reviewexpertstatus.registrytime' })"
      prop="registryTime" width="200">
    </el-table-column>
    <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="230">
      <template #default="scope">
        <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">{{
    $t('kbReview.approve', { msg: 'kbReview.approve' }) }}</el-button>
        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete',
    { msg: 'kbReview.delete' }) }}</el-button>
      </template>
    </el-table-column>
  </el-table>
  <!-- 分页组件 -->
  <el-pagination background layout="sizes,prev, pager, next,jumper,->,total" :page-size="this.pageParam.pageSize"
    :current-page="this.pageParam.pageNum" :page-sizes="pageSizes" :total="total" :hide-on-single-page="true"
    @current-change="handleCurrentChange" @size-change="handleSizeChange">
  </el-pagination>

  <el-dialog :title="$t('reviewexpertstatus.auditusers', { msg: 'reviewexpertstatus.auditusers' })"
    v-model="dialogFormVisible" :before-close="typeDialogClose" width="30%">
    <el-form :model="updateForm" ref="updateForm" :rules="passrules" label-width="85px">
      <el-form-item :label="$t('reviewexpertstatus.profileimage', { msg: ' reviewexpertstatus.profileimage' })">
        <el-input v-model="updateForm.profileimage" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reviewexpertstatus.applyinstruction', { msg: ' reviewexpertstatus.applyinstruction' })">
        <el-input type="textarea" v-model="updateForm.applyTips" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('reviewexpertstatus.attachment', { msg: ' reviewexpertstatus.attachment' })"
        v-if="outsiderFileTable != undefined && outsiderFileTable != null && outsiderFileTable.length > 0">
        <el-table :data="outsiderFileTable">
          <el-table-column :label="$t('reviewexpertstatus.filename', { msg: ' reviewexpertstatus.filename' })"
            prop="fileName"></el-table-column>
          <el-table-column :label="$t('reviewexpertstatus.filetype', { msg: ' reviewexpertstatus.filetype' })"
            prop="fileType"></el-table-column>
          <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })">
            <template #default="scope">
              <el-button size="mini" type="success" @click="handleLoadTrace(scope.$index, scope.row.fileUrl)">{{
    $t('issue.table.download', { msg: 'issue.table.download' }) }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item :label="$t('reviewexpertstatus.specialization', { msg: ' reviewexpertstatus.specialization' })">
        <el-input v-model="updateForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reviewexpertstatus.location', { msg: ' reviewexpertstatus.location' })">
        <el-input v-model="updateForm.location" autocomplete="off"></el-input>
      </el-form-item>

      <!-- <el-form-item :label="$t('reviewexpertstatus.password', { msg: ' reviewexpertstatus.password' })" >
       <el-input v-model="updateForm.password" autocomplete="off"></el-input>
     </el-form-item> -->
      <!-- <el-form-item :label="$t('reviewexpertstatus.userRole', { msg: ' reviewexpertstatus.userRole' })" >
       <el-select style="width: 100%" v-model="updateForm.roleId" :placeholder="$t('reviewexpertstatus.inputuserrole', { msg: ' reviewexpertstatus.inputuserrole' })">
             <el-option
             v-for="item in options"
             :key="item.id"
             :label="item.label"
             :value="item.value">
             </el-option>
       </el-select>
     </el-form-item> -->
      <!-- <el-form-item :label="$t('reviewexpertstatus.companyName', { msg: ' reviewexpertstatus.companyName' })" prop="companyName">
        <el-select
                 style="width: 100%"
                 v-model="updateForm.companyName"     
                 filterable
                 allow-create
                 default-first-option
                 :placeholder="$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' })">
                 <el-option
                 v-for="item in companyData"
                 :key="item.companyID"
                 :label="item.companyname"
                 :value="item.companyname">
                 </el-option>
             </el-select>
     </el-form-item>  -->
      <el-form-item :label="$t('reviewexpertstatus.passstatus', { msg: ' reviewexpertstatus.passstatus' })">
        <el-radio-group v-model="updateForm.isExpert">
          <el-radio :label="2">{{ $t('reviewexpertstatus.passno', { msg: 'reviewexpertstatus.passno' }) }}</el-radio>
          <el-radio :label="1">{{ $t('reviewexpertstatus.passto', { msg: 'reviewexpertstatus.passto' }) }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div>
      <el-button @click="dialogFormVisible = false">{{ $t('reviewexpertstatus.calcel', {
    msg:
      'reviewexpertstatus.calcel'
  }) }}</el-button>
      <el-button type="primary" @click="editKb('updateForm')">{{ $t('reviewexpertstatus.sure', { msg:
        'reviewexpertstatus.sure' }) }}</el-button>
    </div>
  </el-dialog>

</template>

<script>
import { baseUrl_New } from '../../axios/urlconfig';
import axios from 'axios';
import { deleteRequest, getRequest, postRequest } from '../../axios/axios';

export default {
  data() {
    return {
      tableData: [],
      pageParam: {//分页参数
        pageNum: 1,//当前页
        pageSize: 10,//每页条目数据
      },
      total: 0,//总条目数
      pageSizes: [10, 20, 30, 40],//每页显示条目数列表
      dialogFormVisible: false,
      updateForm: {
        //  id:'',
        //  name:'',
        //  username:'',
        //  userId:'',
        //  passwordPlainText: '',
        //  password:'',
        //  roleId:'',
        //  companyId:'',
        //  companyName: '',
        //  applyTips:'',
        //  isExpert:'',
        id: '',
        // name: '',
        // username: '',
        isExpert: '',
        // location: '',
        // email: '',
        // phoneNumber: '',
        // registryTime: '',
        // profileImage: '',
        // specialization: '',

      },
      options: [
        {
          id: 1,
          value: 3,
          label: '客户'
        },
        {
          id: 2,
          value: 4,
          label: '普通管理员'
        },
        {
          id: 3,
          value: 5,
          label: '专家'
        }
      ],
      companyData: [],
      outsidertableid: '',
      outsiderFileTable: [],
      passrules: {
        companyName: [
          { required: true, message: this.$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' }), trigger: 'click' }
        ],
        isExpert: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ],
      },


    }
  },

  created() {
    this.getAllList();
    this.getcompanylist();
  },

  methods: {
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      //  const { id, isExpert } = this.updateForm;
      //  const params = new URLSearchParams();
      //   params.append('id', id);
      //   params.append('isExpert', isExpert);

      this.updateForm = JSON.parse(JSON.stringify(row));
      // this.updateForm = 
      //调用查询文件的方法
      this.outsidertableid = this.updateForm.id;
      this.getResumeTable();
    },
    typeDialogClose() {  //关闭审核对话框
      this.dialogFormVisible = false;
    },

    getAllList() {
      getRequest(baseUrl_New + '/expert/page/' + this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response => {
        //获得服务器端回传的map对象
        console.log(response);
        let resultMap = response.data.expertPageInfo;
        //从集合中获取用户列表及总条目数
        //this.tableData = resultMap.list;
        //  this.tableData =resultMap.list;  
        this.tableData = resultMap.list.map(item => {
          return {
            ...item,
            registryTime: item.registryTime ? item.registryTime.replace('T', ' ') : ''
          };
        });



        this.total = response.data.expertPageInfo.total;
      })
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageParam.pageSize = val;
      this.getAllList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageParam.pageNum = val;
      this.getAllList();
    },
    handleDelete(index, id) {
      this.$confirm(this.$t('agent.deleteDF', { msg: 'agent.deleteDF' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
        confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
        cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        deleteRequest(baseUrl_New + `/expert/delete/${id}`)
          .then(response => {
            // console.log(response);
            this.getAllList();
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))

          }).catch(err => {
            this.$message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
          })
      })
    },
    editKb(formName) { //审核用户
      this.$refs[formName].validate((valid) => {
        //  if (valid) {
        //  var that = this
        if (valid) {
          const { id, isExpert } = this.updateForm;
          //  postRequest(baseUrl_New + '/expert/review' + this.updateForm.id
          //  ,{
          //   //  id:this.updateForm.id,
          //   //  name:this.updateForm.name,
          //   //  username:this.updateForm.username,
          //   //  password:this.updateForm.password,
          //   //  passwordPlainText: this.updateForm.passwordPlainText,
          //   //  userId:this.updateForm.userId,
          //   //  roleId:this.updateForm.roleId,
          //   //  companyName:this.updateForm.companyName,
          //   //  companyId:this.updateForm.companyId,
          //   //  isExpert:this.updateForm.isExpert
          //   //  id:this.updateForm.isExpert,
          //   //  isExpert:this.updateForm.isExpert,
          //   // params: {
          //   // id: this.updateForm.id,
          //   // isExpert: this.updateForm.isExpert
          //   params: {
          //   id: this.updateForm.id,
          //   isExpert: this.updateForm.isExpert
          // }
          //   //  location:this.updateForm.location,
          //   //  email:this.updateForm.email,
          //   //  phoneNumber:this.updateForm.phoneNumber,
          //   //  registryTime:this.updateForm.registryTime,
          //   //  profileImage:this.updateForm.profileImage

          //  }).then(resp=>{
          //    this.typeDialogClose();
          //    this.getAllList();
          //    //清空form输入框
          //    this.updateForm={};
          //    this.$message.success(this.$t('kbReview.reviewS', { msg: 'kbReview.reviewS' }));
          //  }).catch(err => {
          //    this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
          //  })
          //    } else {

          //      return false;
          //    }
          //  });
          postRequest(baseUrl_New + '/expert/review?id=' + this.updateForm.id + '&' + 'isExpert=' + this.updateForm.isExpert
          ).then(resp => {
            this.typeDialogClose();
            this.getAllList();
            //清空form输入框
            this.updateForm = {};
            this.$message.success(this.$t('kbReview.reviewS', { msg: 'kbReview.reviewS' }));
          }).catch(err => {
            this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
          })
        } else {

          return false;
        }
      });

    },
    getcompanylist() {
      getRequest(baseUrl_New + '/company/getlist').then(response => {
        // getRequest(baseUrl_New+'/expert/page').then(response=>{

        this.companyData = response;
      })
    },
    getResumeTable() {
      getRequest(baseUrl_New + '/out/list/' + this.outsidertableid).then(response => {
        this.outsiderFileTable = response.data.list;
      })
    },
    //文件下载
    handleLoadTrace(index, fileUrl) {
      getRequest(baseUrl_New + '/oss/file/downloadFile?fileUrl=' + fileUrl, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      }).catch(
        (error) => {
          this.$message.error(this.$t('issue.issueInfoFile', { msg: 'issue.issueInfoFile' }))
        }
      );
    },


  }
}
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>